import { axios } from "@Root/API";

export const getStudiesStudyProgrammeFundingAndMonitoringOptions = () => {
  return axios.get("get/funding-and-monitoring/student-course-session");
};
